import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SvgIcon from "components/Common/SvgIcon";
import SvgImage from "components/Common/SvgImage";
import previewBackground from "icons/previewBackground.svg";
import classNames from "classnames";
import ImmutablePropTypes from "react-immutable-proptypes";
import { Client, Language } from "resourceModels";
import { getResource, getResources } from "selectors/resources";

/**
 * @param {Object} props
 * @returns {ReactElement}
 */
export class GreetingVideoPreview extends React.PureComponent {
  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      /** @type Client */
      client,
      languages
    } = this.props;
    const backgroundColor = client.chatButton.get("backgroundColor");
    const chatButtonIconPath = client.chatButton.get("iconPath") || "https://d124s1zbdqkqqe.cloudfront.net/Dialogue.svg";
    const buttonSize = client.chatButton.get("size");
    const iconSize = buttonSize / 1.57;
    const emojiSize = buttonSize / 1.3;

    return (
      <div className="Greeting__right-column">
        <SvgImage
          imageHash={previewBackground}
          customClassName="Greeting__right-column__web-background"
        />
        <div
          className="Greeting__right-column__video-player"
          onAnimationEnd={this.props.handleAnimationEnd}
        >
          {/* Not going to have a keyboard handler */}
          <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus, max-len
            role="button"
            className={classNames(
              "Greeting__right-column__play-button",
              { "Greeting__right-column__play-button--clicked": this.props.clicked }
            )}
            onClick={this.props.handlePreviewClick}
          >
            <SvgIcon icon="PlaybackPlayButton" fillColor="inherit" />
          </div>
          <div className="Greeting__right-column__preview-wrapper">
            <p
              className={classNames(
                "Greeting__right-column__message", {
                  "Greeting__right-column__message__scale-animation": (
                    this.props.clicked && this.props.getValue("style") === "Text"
                  )
                }
              )}
              style={this.props.getValue("style") !== "Text" ? { opacity: 0 } : {}}
            >
              {
                Boolean(languages) &&
                this.props.getValue("body", "messageText", this.props.getValue("activeLanguage"))
                  ? this.props.getValue("body", "messageText", this.props.getValue("activeLanguage"))
                  : "Add your greeting message here!"
              }
            </p>
            <div
              className="Greeting__right-column__chaperone"
              style={{
                width: buttonSize,
                height: buttonSize
              }}
            >
              <div
                className="Greeting__right-column__chaperone__circle"
                style={{
                  backgroundColor,
                  width: buttonSize,
                  height: buttonSize
                }}
              >
                <div
                  className={classNames(
                    "Greeting__right-column__chaperone__dialogue",
                    { "Greeting__right-column__chaperone__fade-animation": this.props.clicked && this.props.getValue("style") === "Emoji" }
                  )}
                  style={{
                    backgroundImage: `url(${chatButtonIconPath})`,
                    backgroundSize: iconSize
                  }}
                />
                <div className={classNames(
                  "Greeting__right-column__chaperone__custom-emoji",
                  { "Greeting__right-column__chaperone__slide-animation": this.props.clicked && this.props.getValue("style") === "Emoji" }
                )}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: (buttonSize - emojiSize) / 2,
                      left: (buttonSize - emojiSize) / 2
                    }}
                  >
                    <SvgIcon
                      customClassName="Greeting__right-column__chaperone__emoji"
                      icon={this.props.selectedEmoji}
                      height={emojiSize}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GreetingVideoPreview.propTypes = {
  clicked: PropTypes.bool.isRequired,
  handlePreviewClick: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  selectedEmoji: PropTypes.string.isRequired,
  handleAnimationEnd: PropTypes.func.isRequired,

  client: PropTypes.instanceOf(Client).isRequired,
  languages: ImmutablePropTypes.listOf(PropTypes.instanceOf(Language)).isRequired
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client"),
    languages: getResources(state, "language")
  };
}

const Connector = connect(mapStateToProps)(GreetingVideoPreview);

Connector.propTypes = {
  clicked: PropTypes.bool.isRequired,
  handlePreviewClick: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  selectedEmoji: PropTypes.string.isRequired,
  handleAnimationEnd: PropTypes.func.isRequired
};

export default Connector;
